import React from 'react';
import noop from 'mn-utils/noop';

import {BtnBlueOutlined} from "../../../Buttons";

const additionalBtnCtor = (BtnComponent) => ({children, formCtx, onClick, loading, disabled}) => {
  const formIsLoading = formCtx && (formCtx.state || {}).loading;

  return (
    <BtnComponent
      type="button"
      onClick={onClick || noop}
      loading={formIsLoading || loading}
      disabled={disabled}
    >
      {children}
    </BtnComponent>
  )
};

export const FormAdditionalBtnMerchant = additionalBtnCtor(BtnBlueOutlined);
